enum MedicalSummarySections {
    PreventiveActivitiesSection,
    FollowUpsSection,
    ActiveProblemsSection,
    ActiveMedicationSection,
    MedicalAntecedentsSection,
    AllergiesAndIntoleranceSection,
    ChirurgicalAntecedentsSection,
    SocialHabitsSection,
    PsychiatricAntecedentsSection,
    AlertsAndSpecialNeedsSection,
    ObstetricalAntecedentsSestion,
    ImmunizationsSection,
    FamilyHistorySection,
    VitalSignsSection
}

export { MedicalSummarySections };
